import { z } from 'zod'

import { useFormWithZod } from '@/hooks/useFormWithZod'

const schema = () =>
  z.object({
    questions: z
      .array(z.number().or(z.string()), {
        required_error: 'Select at least one question',
      })
      .min(1, 'Select at least one question'),
  })

export type ConfirmLockingFormModalModel = z.infer<ReturnType<typeof schema>>

export const useConfirmLockingFormModal = () => {
  const confirmLockingFormModalTypeSchema = schema()
  const { form, rule } = useFormWithZod(confirmLockingFormModalTypeSchema)
  return { form, rule, schema: confirmLockingFormModalTypeSchema }
}
